/**
 * Form composite component exports
 *
 * Spacing comes from Flex. This module exports the form element and its props.
 */
export { Form, type FormProps } from './Form';
